define('bizzabo/views/LeftPanelView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/views/popup/ConfirmDialogView',
    'bizzabo/views/popup/TutorialView',
    'hbars!bizzabo/templates/leftPanel',
    'hbars!bizzabo/templates/personItem'
], function(
    $,
    Backbone,
    _,
    Global,
    UTILS,
    Consts,
    CONFIG,
    ConfirmDialogView,
    TutorialView,
    leftPanelTemplate,
    personItemTemplate
    ) {

    var LeftPanelView = Backbone.View.extend({

        events : {
            // tabs
            'click li.information' : 'openEventInfoTab',
            'click li.agenda' : 'openAgendaTab',
            'click li.community' : 'openCommunityTab',
            'click li.dashboard' : 'openDashboardTab',
            'click li.sponsors' : 'openSponsorsTab',
            'click li.polls' : 'openPollsTab',

            // bottom menu
            'click .signInButton' : 'formSignIn',
            'click li.tutorial' : 'openTutorial',

            // my events actions
            'click .addEvent' : 'formNewEvent'
        },

        isMainPageLocked : false,
        isMainPanelShiftedRight : false,
        personView : undefined,

        initialize : function() {
            _.bindAll(this, 'switchTab', 'activeEventSwitched');

            Backbone.on(Consts.Notifications.signin.SIGNED_OUT, this.modelSignOut, this);
            Backbone.on(Consts.Notifications.signin.SIGNED_IN, this.render, this);
            Backbone.on(Consts.Notifications.mainPage.SWITCHED, this.unlockMainPage, this);
            Backbone.on(Consts.Notifications.activeEvent.SWITCHED, this.activeEventSwitched, this);
            Backbone.on(Consts.Notifications.leftPanel.SWITCH_TAB_REQUEST, this.switchTab, this);

            var person = Global.modelPool.getMe();
            this.personView = new PersonItemView({
                model : person
            });

            this.packageView = new PackageView({
                el : this.$('.package-menu')
            });
        },

        remove : function() {
            Backbone.off(Consts.Notifications.signin.SIGNED_OUT, this.modelSignOut, this);
            Backbone.off(Consts.Notifications.signin.SIGNED_IN, this.render, this);
            Backbone.off(Consts.Notifications.mainPage.SWITCHED, this.unlockMainPage, this);
            Backbone.off(Consts.Notifications.activeEvent.SWITCHED, this.activeEventSwitched, this);
            Backbone.off(Consts.Notifications.leftPanel.SWITCH_TAB_REQUEST, this.switchTab, this);
            this.personView.remove();
            this.off();
            this.$el.remove();
        },

        activeEventSwitched : function(notification) {
            var oldActiveEventId = notification.oldActiveEvent && (notification.oldActiveEvent.get('id') || 'new');
            var newActiveEventId = notification.newActiveEvent && (notification.newActiveEvent.get('id') || 'new');

            notification.oldActiveEvent && this.stopListening(notification.oldActiveEvent);
            this.listenTo(notification.newActiveEvent, 'validated', this.activeEventValidated);
            this.activeEventValidated(true);

            var oldActiveAgenda = oldActiveEventId && Global.modelPool.getAgenda(oldActiveEventId);
            var newActiveAgenda = newActiveEventId && Global.modelPool.getAgenda(newActiveEventId);
            oldActiveAgenda && this.stopListening(oldActiveAgenda);
            this.listenTo(newActiveAgenda, 'agendaValidated', this.activeAgendaValidated);
            this.activeAgendaValidated(true);

            var oldActivePartners = oldActiveEventId && Global.modelPool.getPartners(oldActiveEventId);
            var newActivePartners = newActiveEventId && Global.modelPool.getPartners(newActiveEventId);
            oldActivePartners && this.stopListening(oldActivePartners);
            this.listenTo(newActivePartners, 'partnersValidated', this.activePartnersValidated);
            this.activePartnersValidated(true);

            this.renderEditorBtn();
        },

        activeEventValidated : function(isValid, model, errors) {
            var numberOfErrors = isValid ? 0 : _.size(errors);
            this.renderTabError('information', numberOfErrors);
        },

        activeAgendaValidated : function(isValid, model, numberOfErrors) {
            var numberOfErrors = (isValid ? 0 : numberOfErrors);
            this.renderTabError('agenda', numberOfErrors);
        },

        activePartnersValidated : function(isValid, model, errors) {
            var numberOfErrors = isValid ? 0 : UTILS.leafCount(errors);
            this.renderTabError('sponsors', numberOfErrors);
        },

        renderTabError: function(tabClass, numberOfErrors) {
            var element = this.$('li.' + tabClass + ' .error');
            if (numberOfErrors <= 0) {
                element.empty().addClass('hide');
            } else {
                element.text(numberOfErrors).removeClass('hide');
            }
        },

        renderToolTips : function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                placement : 'top'
            });
        },

        render : function() {
            var html = leftPanelTemplate(this.model.toJSON());
            this.$el.html(html);

            this.renderToolTips();

            this.$('.personItem').html(this.personView.render().el);

            this.packageView.setElement(this.$('.package-menu'));
            this.packageView.render();

            if (Global.appView && Global.appView.mainView) {
                Global.appView.selectTab();
            }

        },

        renderEditorBtn: function() {
            var event = Global.modelPool.getActiveEvent();
            this.$('.left-panel-editor-link').attr("href",CONFIG.DASHBOARD_URL +'/preview/'+ event.get('account-id') + '/events/' + event.get('id'));
        },

        modelSignOut : function() {
            window.location = CONFIG.MARKETING_URL;
        },

        formSignIn : function() {
            Backbone.trigger(Consts.Notifications.analytics.SET_USER_TYPE, false);
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'Sign-in clicked'
            });
            Backbone.trigger('loginRequest');
        },

        formNewEvent : function() {
            var thisView = this;
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'Add event clicked'
            });

            var hasEventDraft = false;
            var showNotification = function() {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "Only a single un-saved event is allowed, you are currently editing your existing draft",
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.WARNING,
                    autoHide : true
                });
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Attempted to add another draft'
                });
            };

            var navigateToNewEvent = function() {
                var cb = undefined;
                if (hasEventDraft) {
                    cb = showNotification();
                }
                Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, 'event/new', {
                    trigger : true
                });
            };

            var eventId = this.getActiveEventId();
            var msgTxt = 'You have unsaved data, are you sure you want to create a new event?';

            if (Global.modelPool.hasEventDraft()) {
                msgTxt = "You have unsaved data, are you sure you want to edit the draft event?";
                hasEventDraft = true;
            }

            if (eventId == 'new') {
            } else if (Global.modelPool.isActiveEventNotSaved()) {
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Unsaved data confirmation- Add event'
                });

                new ConfirmDialogView({
                    title : 'Unsaved work',
                    text : msgTxt,
                    confirm : 'OK',
                    cancel : 'Cancel',
                    onConfirm : navigateToNewEvent
                }).show();
            } else {
                navigateToNewEvent();
            }
        },

        getActiveEventId : function() {
            var eventToActivate = Global.modelPool.getActiveEvent();
            var eventId = eventToActivate ? eventToActivate.get('id') : undefined;
            if (eventToActivate && eventToActivate.isNew()) {
                eventId = 'new';
            }
            return eventId;
        },

        mainTabClass : function() {
            var mainView = Global.appView.mainView;
            return mainView && mainView.tabClass;
        },

        isMainTabTypeEquals : function(otherTabClass) {
            return (this.mainTabClass() == otherTabClass);
        },

        switchTab : function(tabName, extraSuffix) {
            var method = 'open' + tabName + 'Tab';
            this[method] && this[method](extraSuffix);
        },

        openTab : function(tabClass, routeSuffix, extraSuffix) {
            Backbone.trigger(Consts.Notifications.leftPanel.TAB_SWITCHED, tabClass);

            if (this.isMainPageLocked) {
                return;
            }
            if (!extraSuffix && this.isMainTabTypeEquals(tabClass)) {
                return;
            }

            this.lockMainPage();
            routeSuffix = routeSuffix || '';
            extraSuffix = extraSuffix ? (extraSuffix + '?force_refresh=' + (new Date()).getTime()) : '';
            var eventId = this.getActiveEventId();
            Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, '/event/' + eventId + routeSuffix + extraSuffix, {
                trigger : true
            });
        },

        openDashboardTab : function() {
            this.openTab(Consts.UI.tabClasses.DASHBOARD, '/dashboard');
        },

        openPromoteTab : function() {
            this.openTab(Consts.UI.tabClasses.PROMOTE, '/promote');
        },

        openSponsorsTab : function(extraSuffix) {
            extraSuffix = _.isString(extraSuffix) ? extraSuffix : null;
            this.openTab(Consts.UI.tabClasses.SPONSORS, '/sponsors', extraSuffix);
        },

        openPollsTab : function(extraSuffix) {
            extraSuffix = _.isString(extraSuffix) ? extraSuffix : null;
            this.openTab(Consts.UI.tabClasses.POLLS, '/polls', extraSuffix);
        },

        openPartnersTab : function() {
            this.openTab(Consts.UI.tabClasses.PARTNERS, '/partners');
        },

        openEventInfoTab : function(extraSuffix) {
            extraSuffix = _.isString(extraSuffix) ? extraSuffix : null;
            this.openTab(Consts.UI.tabClasses.INFORMATION, '', extraSuffix);
        },

        openAgendaTab : function(extraSuffix) {
            extraSuffix = _.isString(extraSuffix) ? extraSuffix : null;
            this.openTab(Consts.UI.tabClasses.AGENDA, '/agenda', extraSuffix);
        },

        openCommunityTab : function() {
            this.openTab(Consts.UI.tabClasses.COMMUNITY, '/community');
        },

        openTutorial : function() {
            $('body').append("<div class='tutorial-popup-div'></div>");
            var tutorial = new TutorialView({
                el: $('.tutorial-popup-div')
            });
            tutorial.render();

        },

        lockMainPage : function() {
            this.isMainPageLocked = true;
            Global.appView.$(".mainPanelHider").show();
            $("body").addClass('lockMainPage');
        },

        unlockMainPage : function() {
            this.isMainPageLocked = false;
            Global.appView.$(".mainPanelHider").hide();
            $("body").removeClass('lockMainPage');
        },

        shiftMainPanelToRight : function() {
            if (this.isMainPanelShiftedRight) {
                return;
            }

            var appView = Global.appView;
            appView.mainView && appView.mainView.hideDetails();
            appView.$(".main").addClass("mainOnRight");
            appView.$(".top").addClass("topOnRight");
            appView.$(".topPanelButtons").addClass("topPanelButtonsOnRight");
            appView.$(".trackTitles").addClass("trackTitlesOnRight");
            appView.$(".growTab .growHeader").addClass("growHeaderOnRight transition");
            this.lockMainPage();
            this.isMainPanelShiftedRight = true;
        },

        shiftMainPanelBackLeft : function(cb) {
            if (!this.isMainPanelShiftedRight) {
                return;
            }

            var appView = Global.appView;
            appView.mainView && appView.mainView.showDetails();
            appView.$(".main").removeClass("mainOnRight");
            appView.$(".top").removeClass("topOnRight");
            appView.$(".topPanelButtons").removeClass("topPanelButtonsOnRight");
            appView.$(".trackTitles").removeClass("trackTitlesOnRight");
            appView.$(".growTab .growHeader").removeClass("growHeaderOnRight");
            _.delay(function() {
                Global.appView.$(".growTab .growHeader").removeClass("transition");
            }, 400);

            this.unlockMainPage();
            this.isMainPanelShiftedRight = false;
            cb && cb();
        }
    });

// Sub Views

    var PersonItemView = Backbone.View.extend({

        events : {
            'click a.signOutButton' : 'formSignOut'
        },

        initialize : function() {
            this.listenTo(Backbone, Consts.Notifications.signin.SIGNED_IN, this.modelSignIn);
            this.listenTo(this.model, 'change', this.render);
            this.model.fetch();
        },

        render : function() {
            var html = personItemTemplate(this.model.toJSON());
            this.$el.html(html);
            return this;
        },

        modelSignIn : function() {
            this.model.fetch();
        },

        formSignOut : function(e) {
            e.preventDefault();
            Backbone.trigger(Consts.Notifications.analytics.SET_USER_TYPE, false);
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'sign-out clicked'
            });

            var actionFunction = function() {
                Global.modelPool.getAuth().signOut();
            };

            if (Global.modelPool.isActiveEventNotSaved()) {
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Unsaved data confirmation- Sign out'
                });

                new ConfirmDialogView({
                    title : 'Unsaved work',
                    text : 'You have unsaved data, are you sure to want to sign out?',
                    confirm : 'Sign Out',
                    cancel : 'Keep working',
                    onConfirm : actionFunction
                }).show();
                return;
            }
            actionFunction();
        }
    });

    var PackageView = Backbone.View.extend({

        initialize : function() {
            this.setModel();
            this.listenTo(Backbone, Consts.Notifications.activeEvent.SWITCHED, this.setModel);
        },

        setModel : function() {
            this.model && this.stopListening(this.model);
            var event = Global.modelPool.getActiveEvent();
            var eventId = (event && event.id) || 'new';
            this.model = Global.modelPool.getServicePlan(eventId);
            this.listenTo(this.model, 'change', this.renderPackage);
            this.renderPackage();
        },

        renderPackage: function() {
            var name = this.model.get('name') || 'Basic';
            this.$('.package-menu-name').text(name + ' Package');
            this.$('.package-upgrade a').attr('href', '/account/cart?' + this.model.upgradeUrlQuery());
        }
    });

    return LeftPanelView;

});
